import styled from 'styled-components';
import { Dialog, LinearProgress } from '@equinor/eds-core-react';
import { spacings } from '../../../tokens/spacings';

export const UploadDialog = styled(Dialog)`
  min-width: 420px;
  max-width: 560px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacings.MEDIUM};
`;

export const ProgressSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacings.SMALL};
`;

export const StyledProgress = styled(LinearProgress)`
  width: 100%;
`;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${spacings.SMALL};
  padding: ${spacings.SMALL};
  border: 1px solid #dcdcdc;
  border-radius: 4px;
`;

export const Actions = styled(Dialog.Actions)`
  display: flex;
  flex-flow: row nowrap;
  column-gap: ${spacings.SMALL};
`;
